import msalInstance from "./MsalInstance";

const instance = msalInstance;

export async function logoutEntraID() {
    instance.logoutRedirect({
        postLogoutRedirectUri: null,
    });
}
